import { Action, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';
import * as modifiedFirstParties from './modified-first-parties.reducers';
import { ModifiedPayeeNames } from '../models/FirstParties';

export const modifiedFirstPartiesKey = 'modifiedFirstParties';

export interface ModifiedFirstPartiesState {
  [modifiedFirstParties.modifiedFirstPartiesKey]: modifiedFirstParties.State;
}

export function reducers(state: ModifiedFirstPartiesState | undefined, action: Action) {
  return combineReducers({
    [modifiedFirstParties.modifiedFirstPartiesKey]: modifiedFirstParties.modifiedFirstPartiesReducer
  })(state, action);
}

export const selectModifiedFirstPartiesFeature = createFeatureSelector<ModifiedFirstPartiesState>(
  modifiedFirstPartiesKey
);

export const selectModifiedFirstParties = createSelector(
  selectModifiedFirstPartiesFeature,
  (state) => {
    return state['firstPartiesOutput'].firstPartyPayees;
  }
);

export const selectModifiedFirstPartyPayeesFormatted = createSelector(selectModifiedFirstParties, (state) => {
  const firstPartyPayees: ModifiedPayeeNames[] = state.map(({payeeNames, approvalStatus, isPrimary}) => {
    const names = payeeNames.map(p => p.name);
    return { name1: names[0], name2: names[1], name3: names[2], pending: approvalStatus === 'Pending', isPrimary: isPrimary};
  })
  return firstPartyPayees;
})